<template>
  <div class="product-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('contact_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-account-cash</v-icon>{{$t('contact.contacts')}}</h1>
        </v-flex>
        <v-flex lg12>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandlerSub"
@contextmenu:row="showHandlerSubExt"
          >
          <template slot="item.comptehub" slot-scope="{ item }">
            <strong v-if="item.comptehub" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandlerSub(item,'Contact',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ContactListCustomer',
  servicePrefix: 'Contact',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar
  },
  props: {
    customerParent: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t('contact.firstname'), value: 'firstname' },
        { text: this.$t('contact.lastname'), value: 'lastname' },
        { text: this.$t('contact.email'), value: 'email' },
        { text: this.$t('contact.phone'), value: 'phone' },
        { text: this.$t('contact.comptehub'), value: 'comptehub' },
      ],
      filters: {
        'customer' : this.customerParent['@id'],
      },
      selected: [],
      options: {sortBy : ['firstname','lastname'], sortDesc : [false,false]}
    };
  },
  computed: {
    ...mapGetters('contact', {
      items: 'list'
    }),
    ...mapFields('contact', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('contact', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
  }
};
</script>
